import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';

const initialValues = {
  zipCode: '',
  waitlistEmail: '',
};

const schema = Yup.object().shape({
  zipCode: capsuleValidation.zip().required('Must be 5 numerical digits'),
  waitlistEmail: capsuleValidation.email('Please enter a valid email address.', 'Required'),
});

const validation = {
  initialValues,
  schema,
};

export default validation;
